export default Object.freeze({
  US: 'INSTANCE_US',
  UK: 'INSTANCE_UK',
  CA: 'INSTANCE_CA',
});
